import { useState, useRef } from 'react';
import { FormState, ImageState, Notification } from './types';

export const useBlogState = () => {
  const [mode, setMode] = useState<'list' | 'view' | 'edit'>('list');
  const [currentNote, setCurrentNote] = useState<any>(null);
  const [isCreating, setIsCreating] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState<Set<string>>(new Set());
  const [search, setSearch] = useState('');
  const [tagFilter, setTagFilter] = useState<string | null>(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null);
  const [confirmDeleteMultiple, setConfirmDeleteMultiple] = useState(false);
  
  const [form, setForm] = useState<FormState>({
    title: '', content: '', image: '', previewImage: '', tags: '', attachments: [],
  });

  const [imageState, setImageState] = useState<ImageState>({
    original: '', cropOpen: false, loading: false,
  });

  const [notification, setNotification] = useState<Notification | null>(null);
  const [paginationMode, setPaginationMode] = useState<'pages' | 'loadMore'>('loadMore');
  const [currentPage, setCurrentPage] = useState(1);
  const [loadedCount, setLoadedCount] = useState(8); // NOTES_PER_PAGE

  const [notes, setNotes] = useState<any[]>([]);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const attachmentInputRef = useRef<HTMLInputElement>(null);

  return {
    mode, setMode, currentNote, setCurrentNote, isCreating, setIsCreating,
    selectedNotes, setSelectedNotes, search, setSearch, tagFilter, setTagFilter,
    confirmDeleteId, setConfirmDeleteId, confirmDeleteMultiple, setConfirmDeleteMultiple,
    form, setForm, imageState, setImageState, notification, setNotification,
    paginationMode, setPaginationMode, currentPage, setCurrentPage, loadedCount, setLoadedCount,
    notes, setNotes, fileInputRef, attachmentInputRef,
  };
};